module.exports = __webpack_public_path__ + "static/img/page1-flag.da0dc0ea.png";